import { default as React } from "react";
import translate from "../../../i18n/translate";
import "./MyScheduleSummaryBlock.scss";
import CloseIcon from '@material-ui/icons/Close';

const RescheduleSecondPage = (props: any) => {
    return (
      <div id="intercept-second-page">
        <CloseIcon className="close-button" fontSize="large" onClick={props.onClose} />
        <div className="jss1591 jss1580">
          <div>
            <div className="jss1592">
              <div>
                <span className="jss1593">
                  <span className="jss1594">
                    <svg className="jss90" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path>
                    </svg>
                  </span>
                  <span className="jss1597">
                    <span className="jss1595">
                      <span>{translate("myschedule_reschedule_next_instr1")}</span>
                    </span>
                  </span>
                </span>
                <div className="jss1596">
                  <span>{translate("myschedule_reschedule_next_instr2")}</span>
                </div>
              </div>
              <div>
                <span className="jss1593">
                  <span className="jss1594">
                    <svg className="jss90" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                      <path fill="none" d="M0 0h24v24H0V0z"></path>
                      <g>
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83z"></path>
                        <path d="M12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"></path>
                      </g>
                    </svg>
                  </span>
                  <span className="jss1597">
                    <span className="jss1595">
                      <span>{translate("myschedule_reschedule_next_instr3")}</span>
                    </span>
                  </span>
                </span>
                <div className="jss1696">
                  <span>{translate("myschedule_reschedule_next_instr4a")} </span>
                  <a href={`${process.env.REACT_APP_GE_SUPPORT_URL}/En-en/contact_support`} target="_blank">
                    <span>{translate("myschedule_reschedule_next_instr4b")}</span>
                  </a>
                  <span>{translate("myschedule_reschedule_next_instr4c", { productname: props.productName })}{" "}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="jss1585">
            <div>
              <span>{translate("myschedule_rechedule_next_info")} </span>
              <a
                href={`${process.env.REACT_APP_GE_SUPPORT_URL}/En-en/getting_started/globalenglishcoach`}
                target="_blank"
                className="jss1587"
              >
                <span>{translate("myschedule_rechedule_next_faq")}</span>
              </a>
            </div>
            <div>
              <label className="jss1674">
                <input
                  type="checkbox"
                  onChange={() => {
                    sessionStorage.getItem("RescheduleChkBox") === "False"
                      ? sessionStorage.setItem("RescheduleChkBox", "True")
                      : sessionStorage.setItem("RescheduleChkBox", "False");
                  }}
                />
                <span className="checkmark"></span>
                <span className="jss177 jss186 jss1677 jss1586">
                  <span>{translate("myschedule_rechedule_next_noShow")}</span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  };

  export default RescheduleSecondPage;